<div class="imgLoginPage" [style.background-image]="'url(' + bgPath + ')'"></div>
<div class="destra">
  <div class="loginForm">
    <img [src]="logoPath" />
    <div class="manutenzione">Il servizio è temporaneamente non disponibile per manutenzione programmata.</div>
    <br>
    <br>
    <div class="manutenzione">Ti invitiamo a riprovare più tardi.</div>
  </div>
  <div class="policy">
    <!-- <p>Term of use. Privacy Policy</p> -->
  </div>
</div>
